
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class BreadcrumbMixin extends Vue {
  updateBreadCrumbs(
    tableUrl: string,
    createUrl: string,
    isCreate: boolean,
    instanceTitle: string,
    instanceEditUrl: string,
    instanceType: string,
    instanceIconClass: string
  ) {
    let breadcrumbs = []

    if (isCreate) {
      breadcrumbs = [
        { title: instanceType, url: tableUrl, icon: instanceIconClass },
        { title: this.$gettext('Create'), url: createUrl }
      ]
    } else {
      breadcrumbs = [
        { title: instanceType, url: tableUrl, icon: instanceIconClass },
        { title: instanceTitle || '', url: instanceEditUrl }
      ]
    }

    this.$emit('breadcrumbs-set', breadcrumbs)
  }
}
